import React from 'react';

export default function CheckboxDashIcon({ width = 11, height = 2, fill = "#171C33" }) {
  return (
    <svg width={width} height={height} viewBox="0 0 11 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.5 1C0.5 0.447715 0.947715 0 1.5 0H9.5C10.0523 0 10.5 0.447715 10.5 1C10.5 1.55228 10.0523 2 9.5 2H1.5C0.947715 2 0.5 1.55228 0.5 1Z" fill={fill}/>
    </svg>
  )
}